// risikoArten.ts — Katalog der Risikoarten für die Risiko-Erfassung.
//
// Herausgelöst aus NewRiskDialog.tsx, damit das „+“-Menü im App-Header
// (neuAnlage/NeuAnlageDialog.tsx) dieselben Kacheln zeigt, ohne den Dialog
// samt Erfassungsfenster zu importieren.

import type * as React from "react";
import {
  Briefcase24Regular,
  Home24Regular,
  VehicleCarProfile24Regular,
  Earth24Regular,
  VehicleTruck24Regular,
  People24Regular,
  Money24Regular,
  ArrowTrendingDown24Regular,
  WeatherSunny24Regular,
  AppGeneric24Regular,
  Wrench24Regular,
  ShieldKeyhole24Regular,
} from "@fluentui/react-icons";

/* ──────────────────────────────────────────────────────────────────────────
   Risk-type catalog — mirrors the Risikoobjekte section in ContactRisksPanel
   ────────────────────────────────────────────────────────────────────────── */

export type NewRiskType =
  | "betriebsvermoegen"
  | "machine"
  | "waren"
  | "elektronik"
  | "betriebSonstige"
  | "immobilie"
  | "kfz"
  | "umwelt"
  | "transport"
  | "menschen"
  | "tobJobber"
  | "liquiditaet"
  | "ertragsausfall"
  | "cyber"
  | "photovoltaik"
  | "sonstiges";

export type SubRisk = { label: string; type: NewRiskType };

export type RisikoArtSpec = {
  key: NewRiskType;
  label: string;
  hint?: string;
  color: string;
  Icon: React.ComponentType<{ style?: React.CSSProperties }>;
  comingSoon?: boolean;
  subRisks?: SubRisk[];
};

const SONSTIGES_HINT = [
  "Risiko Tiere",
  "Risiko aus Rechtsstreitigkeiten",
  "Kann betreffen Risiko Kfz, Risiko Immobilien, Risiko Mitarbeiter",
  "Risiko Radioaktive Geräte o. Stoffe, Röntgenstrahlen",
  "Risiko Firmenfahrräder, E-Bikes",
  "Risiko Kunstgegenstände, wertvolle Objekte",
  "Risiko Luftfahrzeuge",
  "Risiko Fracht-, Passagier-, Spezialschiffe, Kutter, Boote etc.",
  "Risiko Montagen",
  "Risiko Veranstaltungen",
  "Risiko Geschäfts- u. Dienstreisen",
  "Risiko Patente, Marken",
  "Risiko Gewinnspiele",
  "Risiko Schlüsselverlust",
].join("\n");

export const RISIKO_ARTEN: RisikoArtSpec[] = [
  { key: "betriebsvermoegen", label: "Sachwerte", color: "#7c5a3a", Icon: Briefcase24Regular },
  { key: "machine", label: "Maschinen", color: "#57534e", Icon: Wrench24Regular },
  { key: "immobilie", label: "Immobilien", color: "#1e40af", Icon: Home24Regular },
  { key: "kfz", label: "KFZ", color: "#b91c1c", Icon: VehicleCarProfile24Regular },
  { key: "umwelt", label: "Umwelt", color: "#15803d", Icon: Earth24Regular },
  { key: "transport", label: "Transport, Messen u. Ausstellungen", color: "#c2410c", Icon: VehicleTruck24Regular },
  { key: "menschen", label: "Menschen im Unternehmen", color: "#db2777", Icon: People24Regular, comingSoon: true },
  { key: "tobJobber", label: "Tob-Jobber", color: "#7c3aed", Icon: People24Regular, comingSoon: true },
  { key: "liquiditaet", label: "Liquidität", color: "#ca8a04", Icon: Money24Regular },
  { key: "ertragsausfall", label: "Ertragsausfall", color: "#a16207", Icon: ArrowTrendingDown24Regular },
  { key: "cyber", label: "Cyber", color: "#0f172a", Icon: ShieldKeyhole24Regular },
  { key: "photovoltaik", label: "Photovoltaik", color: "#0d9488", Icon: WeatherSunny24Regular, comingSoon: true },
  { key: "sonstiges", label: "Sonstiges", color: "#475569", Icon: AppGeneric24Regular, hint: SONSTIGES_HINT, comingSoon: true },
];
